export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/marketing-tout-3f2bcb795a32a37449d9217f566105d1.jpg";